import '../../assets/css/components/loaderModal.css'
interface LoaderModalProps {
    children?: React.ReactNode; // Prop opcional que acepta cualquier tipo de nodo o mensaje React
}

/*
usabilidad 
 1.  <LoaderModal /> Loader sin mensaje
 2.  <LoaderModal >
        <div> Cargando </div>
     </LoaderModal>  Loader con un mensaje en la parte superior
*/

export default function LoaderModal({ children }:LoaderModalProps) {
    return (
        <div className="loaderModalDiv">
            <div className="loaderModal"></div>
            {children && <div className="loader-message">{children}</div>}
        </div>
    );
}
